module.exports = function (app, mod, images) {
  var imgs = "";
  var tweet_picture_height = 'unset';
  var multi_max_height = '400px';
  if (images.length > 1) {
    tweet_picture_height = 'unset';
    multi_max_height = '200px';
  }
  if (images.length > 2) {
    multi_max_height = '150px';
  }
  if (images.length > 0) {
    for (var i = 0; i < images.length; i++) {
      imgs += "<div><img class=\"image-".concat(i, "\" data-index=\"").concat(i, "\" alt=\"saito dymamic image\" src=\"").concat(images[i], "\"></div>");
    }
  }
  return "<div class=\"saito-img-flex ".concat(images.length == 1 ? 'single-img' : '', "\" style=\"--image-height:").concat(tweet_picture_height, ";--multi-max-height:").concat(multi_max_height, "\">").concat(imgs, "</div>");
};